import { Button, Intent } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import { useTl } from "../../hooks";
import { ICustomButtonProps } from "./ICustomButtonProps";

interface IAddButtonProps extends ICustomButtonProps {}

export const AddButton: React.FunctionComponent<IAddButtonProps> = ({
  minimal = true,
  onClick,
  loading,
  disabled,
  intent = Intent.PRIMARY,
  text,
  hideText,
  small,
  style,
}) => {
  const { t } = useTl();
  return (
    <Button
      icon={IconNames.PLUS}
      minimal={minimal}
      onClick={onClick}
      text={!hideText ? text || t("Add") : null}
      intent={intent}
      loading={loading}
      disabled={disabled}
      small={small}
      style={style}
    />
  );
};
